var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader",attrs:{"id":"loader"}},[_c('div',{staticClass:"loader__block"}),_vm._v(" "),_c('div',{staticClass:"loader__block"}),_vm._v(" "),_c('div',{staticClass:"loader__block"})])}]

export { render, staticRenderFns }